module.exports = __webpack_public_path__ + "static/media/audio_inclusive.51d175ec.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio_inclusive.mp3
// module id = ./src/assets/audio_inclusive.mp3
// module chunks = 0